import { UserInterfaceDto, WidgetDto } from "@intelligems/ig-types";

export function updateUserInterfaceWidgets(
  userInterfaces: UserInterfaceDto[] | undefined,
  widget: WidgetDto
) {
  if (!userInterfaces) {
    return undefined;
  }

  for (const userInterface of userInterfaces) {
    if (userInterface.widget?.id === widget.id) {
      userInterface.widget = widget;
    }
  }
}
